/* eslint-disable max-len */
import 'react';

const SidebarPPTSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        fill="currentColor"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h18v18H0z" />
            <path
                fill="currentColor"
                d="M10.665 5.5c1.146-.005 2.08.95 2.085 2.133.005 1.129-.839 2.068-1.93 2.147l-.155.006H8.788v2.178a.527.527 0 01-.52.536.527.527 0 01-.518-.536V6a.5.5 0 01.5-.5h2.415zM6.5 11a.5.5 0 01.058.997L6.5 12h-1a.5.5 0 01-.058-.997L5.5 11h1zm0-2.5a.5.5 0 01.058.997L6.5 9.5h-1a.5.5 0 01-.058-.997L5.5 8.5h1zm2.249-1.929v2.143h1.916c.573 0 1.037-.48 1.037-1.072a1.06 1.06 0 00-.915-1.063l-.122-.008H8.75zM6.5 6.25a.5.5 0 01.058.997L6.5 7.25h-1a.5.5 0 01-.058-.997L5.5 6.25h1z"
                fillRule="nonzero"
            />
            <path
                d="M4.4 2.5h7A3.5 3.5 0 0114.9 6v7.4a2.1 2.1 0 01-2.1 2.1H5.1A2.1 2.1 0 013 13.4V3.9a1.4 1.4 0 011.4-1.4z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
            />
        </g>
    </svg>
);
export default SidebarPPTSvg;
